const About = () => {
    return (
        <div className="bcard">
        <h1>Hola!</h1>
        <h2>Rick and Morty Project</h2>
        <p>Hola Gente! este es mi proyecto sobre la API de Rick and Morty,
            Estoy utilizando las tecnologias de React y Redux para el Frontend.
            Este proyecto fue realizado para las necesidades solicitadas de la plataforma SoyHenry!
            Espero les guste!
        </p>
        </div>
    );
}

export default About;